module.exports = __webpack_public_path__ + "static/media/apple_pay.1fe14d6b.svg";